<template>
	<div>
    <div class="settings">

        <h2>Settings</h2>
        <hr>

        <DealerProfile ref="dealerProfile" @save="save" v-if="can('access-dealer-profile')"/>
        <MyProfile ref="myProfile" @save="save"/>
    </div>
		<div class="btn-wrapper" style="text-align: right;">
			<div @click="save" class="btn btn-primary">Save</div>
		</div>
	</div>
</template>

<script>
    import DealerProfile  from '@/views/dashboard/tenants/DealerProfile.vue';
    import MyProfile      from '@/views/dashboard/tenants/MyProfile.vue';

    export default {
        name: "Settings",
        components: {
            DealerProfile,
            MyProfile,
        },
				methods: {
					save() {
						if (this.can('access-dealer-profile')) {
							this.$refs.dealerProfile.saveDealer();
						}
						this.$refs.myProfile.saveCurrentUser();
					}
				}
    }
</script>

<style scoped lang="scss">
  .settings {
    //   max-width: 1800px;
  }
</style>
